import React from 'react';
import { AppHeader } from './AppHeader';

interface IRootLayoutProps {
  children: React.ReactNode;
}

export default function RootLayout(props: IRootLayoutProps) {
  return (
    <div className="grid-container">
      <AppHeader />
      <main className="main">{props.children}</main>
    </div>
  );
}
